import React from 'react'
import { createPortal } from 'react-dom'

export const createModal = (children: React.ReactNode) => {
  const modalRoot = document.getElementById('modal-root')!

  return createPortal(children, modalRoot)
}
